import { configureStore } from '@reduxjs/toolkit';

import { sessionReducer } from './pages/Login/reducer';
import { edocReducer } from './pages/DocumentosElectronicos/reducer';
import { reporteReducer } from './pages/Reportes/reducer';
import { usuarioReducer } from './pages/Usuario/CrearUsuario/reducer';

const localStorageMiddleware = ({ getState }) => {
    return (next) => (action) => {
        const result = next(action);
        if (localStorage) {
            localStorage.setItem('applicationState', JSON.stringify(getState()));
        }
        return result;
    };
};

const reHydrateStore = () => {
    const state = localStorage?.getItem('applicationState');
    if (state !== null) {
        return JSON.parse(state); // re-hydrate the store
    }
};

export default configureStore({
    reducer: {
        session: sessionReducer.reducer,
        edoc: edocReducer.reducer,
        reportes: reporteReducer.reducer,
        usuario: usuarioReducer.reducer
    },
    preloadedState: reHydrateStore(),
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredPaths: ['reportes.fromDate', 'reportes.toDate']
            }
        }).concat(localStorageMiddleware)
});
